import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { Componente1Module } from '../../componentes/componente1/componente1.module';
import { CompartidoModule } from '../../compartido/compartido.module';
import { ControlaRutaService } from '../servicios/controla-ruta.service';
import { TableModule } from 'primeng/table';
import { MenuService } from '../servicios/menu.service';
import { CONFIGURACION_ROUTES } from './configuracion.route';
import { CalendarModule, MessageService } from 'primeng/primeng';
import { DisponibilidadPlanificacionNormalListarComponent } from './disponibilidad-planificacion-normal-listar/disponibilidad-planificacion-normal-listar.component';
import { DisponibilidadPlanificacionNormalCrearComponent } from './disponibilidad-planificacion-normal-crear/disponibilidad-planificacion-normal-crear.component';
import { DisponibilidadPlanificacionExcepcionalCrearComponent } from './disponibilidad-planificacion-excepcional-crear/disponibilidad-planificacion-excepcional-crear.component';
import { DisponibilidadPlanificacionExcepcionalListarComponent } from './disponibilidad-planificacion-excepcional-listar/disponibilidad-planificacion-excepcional-listar.component';
import { AsociarJefeDependenciaComponent } from './asociar-jefe-dependencia/asociar-jefe-dependencia.component';
import { BlockUIModule, KeyFilterModule, ProgressSpinnerModule } from 'primeng/primeng';
import { AgregarJefeDependenciaComponent } from './agregar-jefe-dependencia/agregar-jefe-dependencia.component';
import {TreeModule} from 'primeng/tree';
import { ConfiguracionParametrosComponent } from './configuracion-parametros/configuracion-parametros.component';
import {AccordionModule} from 'primeng/accordion';
import { ConfiguracionParametrosEditarComponent } from './configuracion-parametros-editar/configuracion-parametros-editar.component';



@NgModule({
  imports: [
    CommonModule
    , Componente1Module
    , HttpClientModule
    , CompartidoModule
    ,CONFIGURACION_ROUTES
    ,CalendarModule
    ,TableModule
    ,KeyFilterModule
    ,ProgressSpinnerModule
    ,BlockUIModule
    ,TableModule
    ,TreeModule
    ,AccordionModule
    
    

  ],  
  declarations: [
    AsociarJefeDependenciaComponent,
    AgregarJefeDependenciaComponent,
    DisponibilidadPlanificacionNormalListarComponent,
    DisponibilidadPlanificacionNormalCrearComponent,
    DisponibilidadPlanificacionExcepcionalCrearComponent,
    DisponibilidadPlanificacionExcepcionalListarComponent,
    AsociarJefeDependenciaComponent,
    ConfiguracionParametrosComponent,
    ConfiguracionParametrosEditarComponent

  ]
  , providers: [
    
 
     ControlaRutaService
    ,MenuService

  ]
  , exports: [
  
    DisponibilidadPlanificacionNormalListarComponent
    ,DisponibilidadPlanificacionNormalCrearComponent
    //, MenuService

  ]
})
export class ConfiguracionModule { }
